import { render, staticRenderFns } from "./tallypage.vue?vue&type=template&id=fc6c938c"
import script from "./tallypage.vue?vue&type=script&lang=js"
export * from "./tallypage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports